<div class="dashboard-table-container">
  <!-- Search and Filter Section -->
  <div class="table-header">
    <div class="header-spacer"></div>
    
    <div class="search-container">
      <owc-input 
        variant="outlined" 
        rounded
        placeholder="Search..."
        (input)="applyFilter($event)"
        [value]="searchValue">
        <owc-icon slot="suffix" *ngIf="searchValue" (click)="clearSearch()" style="cursor: pointer;">close</owc-icon>
      </owc-input>
    </div>
    
    <!-- Column Visibility Controls -->
    <div class="column-controls">
      <owc-button variant="outlined" (click)="toggleColumnMenu()">
        <owc-icon>settings</owc-icon>
      </owc-button>
      
      <div class="column-menu" *ngIf="showColumnMenu" (click)="$event.stopPropagation()">
        <div class="column-list">
          <div class="column-item">
            <label class="column-checkbox all-checkbox" (click)="toggleAllColumns()">
              <owc-checkbox 
                [checked]="areAllColumnsSelected()"
                [indeterminate]="someColumnsSelected()">
              </owc-checkbox>
              All
            </label>
          </div>
          <div class="column-item" *ngFor="let column of allColumns; trackBy: trackByColumn">
            <label class="column-checkbox" (click)="onColumnSelectionChange(column.key, $event)">
              <owc-checkbox 
                [checked]="getTempColumnState(column.key)">
              </owc-checkbox>
              {{ column.label }}
            </label>
          </div>
        </div>
        <div class="menu-footer">
          <owc-button color="primary" (click)="applyColumnChanges()" class="apply-button">
            Apply
          </owc-button>
        </div>
      </div>
    </div>
  </div>

  <!-- Table Section -->
  <div class="table-wrapper">
    <owc-card class="one-card-flat" style="position:relative">
      <owc-table class="dashboard-table">
      
        <owc-table-header sticky>
          <owc-table-header-cell *ngIf="isColumnVisible('dateCreated')" sortable [align]="'left'" [title]="'dateCreated'" (sortOrderChange)="onSort('dateCreated', $event.detail)">
            Date Created
          </owc-table-header-cell>
          <owc-table-header-cell *ngIf="isColumnVisible('country')" sortable [align]="'left'" [title]="'country'" (sortOrderChange)="onSort('country', $event.detail)">
            Country
          </owc-table-header-cell>
          <owc-table-header-cell *ngIf="isColumnVisible('type')" sortable [align]="'left'" [title]="'type'" (sortOrderChange)="onSort('type', $event.detail)">
            Type
          </owc-table-header-cell>
          <owc-table-header-cell *ngIf="isColumnVisible('localId')" sortable [align]="'left'" [title]="'localId'" (sortOrderChange)="onSort('localId', $event.detail)">
            Local ID
          </owc-table-header-cell>
          <owc-table-header-cell *ngIf="isColumnVisible('accountId')" sortable [align]="'left'" [title]="'accountId'" (sortOrderChange)="onSort('accountId', $event.detail)">
            Account ID
          </owc-table-header-cell>
          <owc-table-header-cell *ngIf="isColumnVisible('accountName')" sortable [align]="'left'" [title]="'accountName'" (sortOrderChange)="onSort('accountName', $event.detail)">
            Account Name
          </owc-table-header-cell>
          <owc-table-header-cell *ngIf="isColumnVisible('accountStatus')" sortable [align]="'left'" [title]="'accountStatus'" (sortOrderChange)="onSort('accountStatus', $event.detail)">
            Account Status
          </owc-table-header-cell>
          <owc-table-header-cell *ngIf="isColumnVisible('delivery')" sortable [align]="'left'" [title]="'delivery'" (sortOrderChange)="onSort('delivery', $event.detail)">
            Delivery
          </owc-table-header-cell>
          <owc-table-header-cell *ngIf="isColumnVisible('feedback')" sortable [align]="'left'" [title]="'feedback'" (sortOrderChange)="onSort('feedback', $event.detail)">
            Feedback
          </owc-table-header-cell>
          <owc-table-header-cell *ngIf="isColumnVisible('globalId')" sortable [align]="'left'" [title]="'globalId'" (sortOrderChange)="onSort('globalId', $event.detail)">
            Global ID
          </owc-table-header-cell>
          <owc-table-header-cell *ngIf="isColumnVisible('dateSent')" sortable [align]="'left'" [title]="'dateSent'" (sortOrderChange)="onSort('dateSent', $event.detail)">
            Date Sent
          </owc-table-header-cell>
          <owc-table-header-cell *ngIf="isColumnVisible('dateDelivered')" sortable [align]="'left'" [title]="'dateDelivered'" (sortOrderChange)="onSort('dateDelivered', $event.detail)">
            Date Delivered
          </owc-table-header-cell>
          <owc-table-header-cell *ngIf="isColumnVisible('dateRead')" sortable [align]="'left'" [title]="'dateRead'" (sortOrderChange)="onSort('dateRead', $event.detail)">
            Date Read
          </owc-table-header-cell>
          <owc-table-header-cell *ngIf="isColumnVisible('dateFeedback')" sortable [align]="'left'" [title]="'dateFeedback'" (sortOrderChange)="onSort('dateFeedback', $event.detail)">
            Date Feedback
          </owc-table-header-cell>
          <owc-table-header-cell *ngIf="isColumnVisible('deliveryFailures')" sortable [align]="'left'" [title]="'deliveryFailures'" (sortOrderChange)="onSort('deliveryFailures', $event.detail)">
            Delivery Failures
          </owc-table-header-cell>
          <owc-table-header-cell *ngIf="isColumnVisible('daysToOpen')" sortable [align]="'left'" [title]="'daysToOpen'" (sortOrderChange)="onSort('daysToOpen', $event.detail)">
            Days to Open
          </owc-table-header-cell>
          <owc-table-header-cell *ngIf="isColumnVisible('daysToSubmit')" sortable [align]="'left'" [title]="'daysToSubmit'" (sortOrderChange)="onSort('daysToSubmit', $event.detail)">
            Days to Submit
          </owc-table-header-cell>
        </owc-table-header>

        <owc-table-body>
          @if(paginatedData && paginatedData.length > 0) {
            @for(element of paginatedData; track element.localId || $index) {
              <owc-table-row class="table-row">
                <owc-table-simple-cell *ngIf="isColumnVisible('dateCreated')" [title]="element.dateCreated | date:'dd-MMM-yy HH:mm:ss'">
                  {{ element.dateCreated | date:'dd-MMM-yy HH:mm:ss' }}
                </owc-table-simple-cell>
                <owc-table-simple-cell *ngIf="isColumnVisible('country')" [title]="element.country">
                  {{ element.country }}
                </owc-table-simple-cell>
                <owc-table-simple-cell *ngIf="isColumnVisible('type')" [title]="element.type">
                  {{ element.type }}
                </owc-table-simple-cell>
                <owc-table-simple-cell *ngIf="isColumnVisible('localId')" [title]="element.localId">
                  <span class="truncate-text">{{ element.localId }}</span>
                </owc-table-simple-cell>
                <owc-table-simple-cell *ngIf="isColumnVisible('accountId')" [title]="element.accountId">
                  <span class="truncate-text">{{ element.accountId }}</span>
                </owc-table-simple-cell>
                <owc-table-simple-cell *ngIf="isColumnVisible('accountName')" [title]="element.accountName">
                  <span class="truncate-text">{{ element.accountName }}</span>
                </owc-table-simple-cell>
                <owc-table-simple-cell *ngIf="isColumnVisible('accountStatus')" [title]="element.accountStatus">
                  <span class="status-badge" [ngClass]="getStatusClass(element.accountStatus)" style="display: block; width: min-content; font-weight: bold;">
                    {{ element.accountStatus }}
                  </span>
                </owc-table-simple-cell>
                <owc-table-simple-cell *ngIf="isColumnVisible('delivery')" [title]="element.delivery">
                  <span class="delivery-badge" [ngClass]="getDeliveryClass(element.delivery)" style="font-weight: bold;">
                    {{ element.delivery }}
                  </span>
                </owc-table-simple-cell>
                <owc-table-simple-cell *ngIf="isColumnVisible('feedback')" [title]="element.feedback">
                  <span class="feedback-badge" [ngClass]="getFeedbackClass(element.feedback)" style="font-weight: bold;">
                    {{ element.feedback }}
                  </span>
                </owc-table-simple-cell>
                <owc-table-simple-cell *ngIf="isColumnVisible('globalId')" [title]="element.globalId">
                  <span class="truncate-text">{{ element.globalId }}</span>
                </owc-table-simple-cell>
                <owc-table-simple-cell *ngIf="isColumnVisible('dateSent')" [title]="element.dateSent | date:'dd-MMM-yy HH:mm:ss'">
                  {{ element.dateSent | date:'dd-MMM-yy HH:mm:ss' }}
                </owc-table-simple-cell>
                <owc-table-simple-cell *ngIf="isColumnVisible('dateDelivered')" [title]="element.dateDelivered | date:'dd-MMM-yy HH:mm:ss'">
                  {{ element.dateDelivered | date:'dd-MMM-yy HH:mm:ss' }}
                </owc-table-simple-cell>
                <owc-table-simple-cell *ngIf="isColumnVisible('dateRead')" [title]="element.dateRead | date:'dd-MMM-yy HH:mm:ss'">
                  {{ element.dateRead | date:'dd-MMM-yy HH:mm:ss' }}
                </owc-table-simple-cell>
                <owc-table-simple-cell *ngIf="isColumnVisible('dateFeedback')" [title]="element.dateFeedback | date:'dd-MMM-yy HH:mm:ss'">
                  {{ element.dateFeedback | date:'dd-MMM-yy HH:mm:ss' }}
                </owc-table-simple-cell>
                <owc-table-simple-cell *ngIf="isColumnVisible('deliveryFailures')" [title]="element.deliveryFailures === 'True' ? 'Yes' : ''">
                  <div style="border-radius: 16px;width: 30px !important; text-align: center;" [ngClass]="{ failedColorDelivery: element.deliveryFailures === 'True' }" class="chip truncate-text" oneChip oneChipAppearance="outline">
                    {{ element.deliveryFailures === 'True' ? 'Yes' : '' }}
                  </div>
                </owc-table-simple-cell>
                <owc-table-simple-cell *ngIf="isColumnVisible('daysToOpen')" [title]="element.daysToOpen">
                  {{ element.daysToOpen }}
                </owc-table-simple-cell>
                <owc-table-simple-cell *ngIf="isColumnVisible('daysToSubmit')" [title]="element.daysToSubmit">
                  {{ element.daysToSubmit }}
                </owc-table-simple-cell>
              </owc-table-row>
            }
          }
        </owc-table-body>
      </owc-table>
    </owc-card>
  </div>


  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <!-- <owc-spinner></owc-spinner> -->
    <p>Loading notifications...</p>
  </div>

  <!-- No Data State -->
  <div *ngIf="!isLoading && (dataSource.length === 0 || filteredData.length === 0)" class="no-data-container">
    <p *ngIf="dataSource.length === 0">No data found</p>
    <p *ngIf="dataSource.length > 0 && filteredData.length === 0">No search results found</p>
  </div>

  <!-- Simple Pagination -->
  <div class="simple-pagination" *ngIf="totalCount > 0">
    <div class="pagination-left">
      <span class="items-per-page-label">Items per page:</span>
      <select 
        class="page-size-dropdown"
        [value]="pageSize" 
        (change)="onPageSizeChange($event)">
        <option *ngFor="let size of pageSizeOptions" [value]="size">
          {{ size }}
        </option>
      </select>
    </div>
    
    <div class="pagination-center">
      <span class="pagination-info">{{ startIndex }} - {{ endIndex }} of {{ totalCount }}</span>
    </div>
    
    <div class="pagination-right">
      <button 
        class="nav-button" 
        [disabled]="currentPage === 0"
        (click)="goToFirstPage()"
        title="First page">
        &#8810;
      </button>
      <button 
        class="nav-button" 
        [disabled]="currentPage === 0"
        (click)="goToPreviousPage()"
        title="Previous page">
        &#8249;
      </button>
      <button 
        class="nav-button" 
        [disabled]="currentPage >= totalPages - 1"
        (click)="goToNextPage()"
        title="Next page">
        &#8250;
      </button>
      <button 
        class="nav-button" 
        [disabled]="currentPage >= totalPages - 1"
        (click)="goToLastPage()"
        title="Last page">
        &#8811;
      </button>
    </div>
  </div>
</div>
